const getMimeType = (fileType) => {
  switch (fileType) {
    case 'pdf':
      return 'application/pdf';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'xls':
      return 'application/vnd.ms-excel';
    case 'docx':
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    default:
      return `application/${fileType}`;
  }
};

export default class ProviderInfoDownloadables {
  constructor(downloadDataService, currentUserService) {
    'ngInject';

    this.downloadDataService = downloadDataService;
    this.currentUserService = currentUserService;
  }

  download(doc) {
    const fileNameSplits = doc.fileName.split('.');
    const type = getMimeType(fileNameSplits[fileNameSplits.length - 1]);
    const content = `data:${type};base64,${doc.content}`;
    this.downloadDataService.download(content, doc.fileName, type);
  }

  isAllowDeletion(isPrivateDoc, isRubik) {
    return !isRubik && (isPrivateDoc || this.currentUserService.isCorporate);
  }
}
